import {
    IntegrationsStore,
    TIntegrationProvider,
} from '@/core/store/Integrations/integrations.store'
import { useRefreshIntegrations } from '../use-refresh-integrations'

export const usePendingProviders = (provider?: TIntegrationProvider) => {
    useRefreshIntegrations()

    const { pendingIntegrationProvidersIds } = IntegrationsStore.useStore()

    const msProvider = IntegrationsStore.getProviderByType('microsoft')
    const googleProvider = IntegrationsStore.getProviderByType('google')
    const googleFraudDefenseProvider = IntegrationsStore.getProviderByType(
        'google_fraud_defense'
    )
    const msFraudDefenseProvider =
        IntegrationsStore.getProviderByType('ms_fraud_defense')

    const isProviderLoading = (provider?: TIntegrationProvider) => {
        if (!provider) return false

        return (
            pendingIntegrationProvidersIds.includes(provider.id) ||
            !!provider.loading
        )
    }

    return {
        isMicrosoftFraudDefenseLoading: isProviderLoading(
            msFraudDefenseProvider
        ),
        isGoogleFraudDefenseLoading: isProviderLoading(
            googleFraudDefenseProvider
        ),
        isGoogleLoading: isProviderLoading(googleProvider),
        isMicrosoftLoading: isProviderLoading(msProvider),
        isCurrentProviderLoading: isProviderLoading(provider),
    }
}
